import React from "react";
import "./New.scss";
import Comingsoon from "../../media/Gading_Desktop.webp";
import Soon from "../../media/Gading_Mobile.webp";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6287713153298&text=Halo%20Billy,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Summarecon%20Crown%20Gading%20(Gading%20Square)+https://marketing-crowngading.com/&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="gadingsquare" className="container-gading">
      <div className="gading">
        <h1>New Launching Summarecon Crown Gading</h1>
        <h2>Gading Square</h2>
      </div>
      <div className="maps-lokasi">
        <img
          id="location"
          className="img-lokasi-dekstop"
          src={Comingsoon}
          alt="maps"
        />
        <img id="lokasi" className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
